import muster from '@dbk-legacy/muster';
import { getValues } from '@dbk-legacy/muster/utils';
import { variable } from '@dbk-legacy/muster/helpers';
import isValidJsonString from '../utils/is-valid-json-string';
import { Base64 } from 'js-base64';
import { ROUTES } from '../constants';
import Guid from '../utils/guid';

export default () => {
  return muster()

    .path('ais.accountConfirmation', {
      call: async ({ req }, { get, set, call }) => {
        await set('ais.isAccountConfirmation', true);
        await set('ais.isManageContactDetails', true);
        if (req.args[0] === "confirm") {
          await set('vascoauthentication.vascoVisible', true);
          await set('ais.isConfirmed', true);
        }
        if (req.args[0] === "reject") {
          await set('ais.isRejected', true);
        }
      }
    })

    .path('ais.getConsentRequest', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        const guidStr = Guid();
        const [userId] = await getValues(get('auth.userId'));
        const base64UserId = Base64.encode(userId);
        const inputParam = `${base64UserId}`;

        const [oReturn] = await getValues(get(`roster.data.ais.getConsentRequest["${inputParam}"]["${guidStr}"]`));

        isValidJsonString(oReturn).then(async (data) => {
          if (Array.isArray(data.consents) && data.consents.length > 0) {
            await set('ais.isBannerVisible', true);
            await set('ais.consentId', data.consents[0].consentId);

            if (data && data.consents && data.consents[0].serviceAction === 'AIS-C') {
              await set('ais.isServiceActionAIS', true);
            }
          }
          else {
            await set('ais.isBannerVisible', false);
          }
        }).catch(async (error) => {
          await set('ais.showSpinner', false);
          await set('ais.errorMsg', messages['app.psd2.payment.generic.errorMsg']);
        })
      }
    })

    .path('ais.getAISConsent', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        const guidStr = Guid();
        await set('ais.showSpinner', true);
        await set('ais.errorMsg', ''); // solved: WMCE-31872 consent detail is not loading at first time
        const [userId] = await getValues(get('auth.userId'));
        const [consentId] = await getValues(get('ais.consentId'));
        const base64ConsentId = Base64.encode(consentId);
        const base64UserId = Base64.encode(userId);

        const inputParam = `${base64UserId}#@#${base64ConsentId}`;
        const [oReturn] = await getValues(get(`roster.data.ais.getAISConsent["${inputParam}"]["${guidStr}"]`));

        isValidJsonString(oReturn).then(async (data) => {
          await set('ais.showSpinner', false);
          if (data && data.consent) {
            await set('ais.consentDetails', data.consent);
            await set('ais.consentType', data.consent.consentType);
            await set('ais.consentAccessData', data.consent.access);
            await set('ais.consentAccountDetails', data.consent.access.accounts);
            //await set('ais.consentId', data.consent.consentId);
          } else if (data && data.code  && data.description && data.severity) {
            await set('ais.errorMsg', data.description);
          } else if (data && data.statusCode !== 200) {
            await set('ais.errorMsg', data.body.description || data.description || messages['app.psd2.payment.generic.errorMsg']);
          } else {
            await set('ais.isBannerVisible', false);
          }
        }).catch(async (error) => {
          await set('ais.showSpinner', false);
          await set('ais.errorMsg', messages['app.psd2.payment.generic.errorMsg']);
        })
      }
    })

    .path('ais.consentUpdate', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();
        const [messages] = await getValues(get('i18n.messages'));
        await set('ais.showSpinner', true);
        const [consentId] = await getValues(get('ais.consentId'));
        const [consentType] = await getValues(get('ais.consentType'));
        const [confirm] = await getValues(get('ais.isConfirmed'));
        const status = confirm ? "APPROVED" : "CANCELLED"
        const remoteUrl = req.args[1];
        const userId = req.args[2];
        const [authHeader] = await getValues(get('auth.authHeader'));;
        const langCode = req.args[4];
        const apiverion = req.args[5].apiverion;
        const branchCode = req.args[6].selectedPortfolio.branchCode;

        const url = remoteUrl + '/psd2aiscservice/' + apiverion + '/consents/ais/update';  // when deploying the changes use this URL 

      const reqObjTemp = {
        consent:{
              consentId,
              consentType,
              status,
              access:req.args[0],
              branchCode:branchCode,
              language:langCode
            }
      }
      const requestOptions = {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization-Token': authHeader,
         // 'Authorization': 'Bearer *****', //use this when testing locally 
          },
        body: JSON.stringify(reqObjTemp)
      };

     // fetch is used to bypass ais/update endpoint
    fetch(url, requestOptions)
      .then(async (respData) => {
        if(respData.status === 200 ){
          return respData.json()
        }else{
          await set('ais.showSpinner', false);
          await set('ais.errorMsg', messages['app.psd2.payment.generic.errorMsg']);
        }
      })
       .then(async (data) => {
         await set('ais.showSpinner', false);
         await set('ais.isAccountConfirmation', false);
         if (data && data.message) {
           const [isConfirmed] = await getValues(get('ais.isConfirmed'));
           const [isRejected] = await getValues(get('ais.isRejected'));
           if (isConfirmed) {
             await set('ais.aisSuccess', true);
             await set('ais.isConfirmed', false);
           }
           if (!isConfirmed) {
             await set('ais.aisSuccess', false);
           }
           await call('ui.history.push', { pathname: ROUTES.PAYMENT.PSD2_AIS });
         } else if (data && data.code) {
           await set('ais.errorMsg', data.description || messages['app.psd2.payment.generic.errorMsg']);
         }
         else {
           await set('ais.isBannerVisible', false);
         }
        }).catch(async (error) => {
            await set('ais.showSpinner', false);
            await set('ais.errorMsg', messages['app.psd2.payment.generic.errorMsg']);
         })                
        await call('vascoauthentication.hideVasco');
      }
    })

    .path('ais.resetStatus', {
      call: async ({ req }, { get, set, call }) => {
        await set('ais.isConfirmed', false);
        await set('ais.isAccountOtpVerified', false);
        await set('ais.isRejected', false);
        await set('ais.isConfirmed', false);
        await set('ais.isBannerVisible', false);
        await set('ais.isServiceActionAIS', false);
        await set('ais.errorMsg', '');
      }
    })

    .path('ais.showSpinner', variable(''))
    .path('ais.isValidData', variable(true))
    .path('ais.isAccountConfirmation', variable(false))
    .path('ais.isManageContactDetails', variable(false))
    .path('ais.isConfirmed', variable(false))
    .path('ais.isRejected', variable(false))
    .path('ais.aisSuccess', variable(null))
    // .path('ais.showReject', variable(false))
    .path('ais.consentId', variable(''))
    .path('ais.isBannerVisible', variable(false))
    .path('ais.consentDetails', variable(''))
    .path('ais.consentAccountDetails', variable([]))
    .path('ais.isAccountOtpVerified', variable(false))
    .path('ais.disctinctRecords', variable(null))
    .path('ais.errorMsg', variable(''))
    .path('ais.isServiceActionAIS', variable(false))
    .path('ais.consentType', variable(''))
    .path('ais.consentAccessData', variable(''))
}